import type { BaseIconName } from '@/js/account/components/base/BaseIcon.vue';
import { AccountRouteName } from '@/js/account/app/router/route-names';

export type ProfileNavItem = {
  routeName: (typeof AccountRouteName)[keyof typeof AccountRouteName]
  icon: BaseIconName
  label: string
};

export const PROFILE_NAV_ITEMS: ProfileNavItem[] = [
  {
    routeName: AccountRouteName.Dashboard,
    icon: 'grid-streamline',
    label: 'Dashboard',
  },
  {
    routeName: AccountRouteName.Library,
    icon: 'book-open',
    label: 'Library',
  },
  {
    routeName: AccountRouteName.Profile,
    icon: 'person',
    label: 'My Profile',
  },
];
